import { render, staticRenderFns } from "./EditNudgingConfig.vue?vue&type=template&id=443046f0&v-slot%3Amodal-body=true&"
import script from "./EditNudgingConfig.vue?vue&type=script&lang=js&"
export * from "./EditNudgingConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports